import { Button } from "@/components/shadcn/button";
import { Range as RangeDate } from "react-date-range";

type Props = {
  selectFunc: (range: RangeDate) => void;
};

const QuickDatePickLinks = ({ selectFunc }: Props) => {
  const selectLastWeek = () => {
    const lastWeek = {
      startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      endDate: new Date(),
      key: "selection",
    };
    selectFunc(lastWeek);
  };

  const selectLastMonth = () => {
    const lastMonth = {
      startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      endDate: new Date(),
    };
    selectFunc(lastMonth);
  };

  const selectLastThreeMonths = () => {
    const lastThreeMonths = {
      startDate: new Date(new Date().setMonth(new Date().getMonth() - 3)),
      endDate: new Date(),
    };
    selectFunc(lastThreeMonths);
  };

  const selectToday = () => {
    const today = new Date();
    const lastDay = {
      startDate: new Date(new Date().setHours(today.getHours() - 1)),
      endDate: today,
    };
    selectFunc(lastDay);
  };

  return (
    <div className="flex space-x-2.5 text-sm">
      <Button onClick={selectLastThreeMonths} variant="secondary">
        Last three months
      </Button>
      <Button onClick={selectLastMonth} variant="secondary">
        Last month
      </Button>
      <Button onClick={selectLastWeek} variant="secondary">
        Last week
      </Button>
      <Button onClick={selectToday} variant="secondary">
        Today
      </Button>
    </div>
  );
};

export default QuickDatePickLinks;
